export const LANDING_STATE_NAME = 'landing';

export const EMPTY_LANDING_PRODUCT_TEXT_KEY = 'landing_series_list_empty';
